import { defineMessages } from 'react-intl';

export const creditCardFormMessages = defineMessages({
    checkoutTitle: {
        id: 'payment.checkoutTitle',
        description: 'Title of the overall checkout form',
        defaultMessage: 'Payment Info'
    },
    billingAddressTitle: {
        id: 'payment.billingAddressTitle',
        description: 'Title of billing address section of checkout form',
        defaultMessage: 'Billing Address'
    },
    yourContactInfoHeader: {
        id: 'payment.yourContactInfoHeader',
        description: 'Header for the purchaser contact information section',
        defaultMessage: 'Your Contact Info'
    },
    creditCardNameLabel: {
        id: 'payment.creditCardNameLabel',
        description: 'Label for name field.',
        defaultMessage: 'Name on Card'
    },
    purchaserEmailLabel: {
        id: 'payment.purchaserEmailLabel',
        description: 'The label for the purchaser email form field',
        defaultMessage: 'Your Email'
    },
    phoneNumberLabel: {
        id: 'payment.phoneLabel',
        description: 'The label for the purchaser phone number form field',
        defaultMessage: 'Phone Number'
    },
    placingOrder: {
        id: 'payment.placingOrder',
        description: 'Modal status message indicating an order placement request is in flight',
        defaultMessage: 'Placing your order...'
    },
    checkoutButtonText: {
        id: 'payment.checkoutButtonText',
        description: 'Label for complete checkout button',
        defaultMessage: 'Complete Order'
    },
    useShippingAddress: {
        id: 'payment.useShippingAddress',
        description: 'Label for option to use saved address',
        defaultMessage: 'Use Shipping Address?'
    }
});
